/* eslint-disable camelcase */
<template>
  <div class="page-container">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div>
      <CardSuperior @selectedStudent="PesquisaLocal" @selectedMenu="SelectedMenuOption"
        :selectedButtom="menuSelected" />
      <showNotifications v-if="pesquisarAlertas" :estudante="estudanteResult[0]" @fecharComponent="closeAlerta" />
      <NovoEstudante v-if="menuSelected == 2" @fecharComponente="NovaVenda" />

      <div v-if="estudanteResult.length && !cardPagamentoFeito && menuSelected != 2" class="grid_container_cards">
        <div class="details-container">
          <informacoesPessoais :estudante="estudanteResult[0]" @selectedMenu="SelectedMenuOption"
            @saldoEstudante="getSaldoestudante" :key="infoPesoaisKey" />
        </div>

        <div class="content-display" style="max-height: 800px; overflow-y: scroll; overflow-x: hidden">
          <div v-if="menuSelected == 13">
            <RegistroUnico :estudante="estudanteResult[0]" @fecharComponente="fecharTelaComponente" />
          </div>

          <div v-if="menuSelected == 1">
            <GerarSaldo :estudante="estudanteResult[0]" :saldo="saldoActual" @fecharComponente="fecharTelaComponente"
              @imprimirComprovativo="pagamentoFeito" />
          </div>
          <div v-if="menuSelected == 3">
            <ConsultarPagamento :estudante="estudanteResult[0]" />
          </div>
          <div v-if="menuSelected == 4">
            <RegistrarBolseiro :estudante="estudanteResult[0]" @fecharComponente="fecharTelaComponente" />
          </div>
          <div v-if="menuSelected == 5">
            <editarEstudante :estudante="estudanteResult[0]" @fecharComponente="fecharTelaComponente" />
          </div>
          <div v-if="menuSelected == 7">
            <alertaEstudante :estudante="estudanteResult[0]" />
          </div>
          <div v-if="menuSelected == 6">
            <confirmarEstudante :estudante="estudanteResult[0]" @fecharComponente="fecharTelaComponente" />
          </div>
          <div v-show="menuSelected == 10">
            <OptionSettingsPagamentos v-show="!showFinalizar" @itemSelected="settingSelected" @dataSelected="getData"
              @trimestreSelected="selectedTrimestre" @cardMaisEmolumento="abrirCardMaisEMolumento"
              @anoLectivoSelected="selecionarAnoLectivo" />
            <CardMaisEmolumentos v-if="popupExtraVisible" :popupVisible="popupExtraVisible"
              :estudante="estudanteResult[0]"  :anolectivoSeletedC="anolectivoSeleted" @fecharCard="abrirCardMaisEMolumento" />
            <TabelaPagamento v-if="dataPagamentoSelected" v-show="!showFinalizar" ref="tabelaComponent"
              :estudante="estudanteResult[0]" :dataPagamento="dataPagamentoSelected"
              @continuarPagamento="PagamentoContinuar" :anoLectivoEscolhido="anolectivoSeleted" />
            <TelaFinalizarPagamento v-if="showFinalizar && trimestreSelecionado" :totais="pagamentototais"
              :venda="pagamentoVenda" :saldo="saldoActual" :estudante="estudanteResult" :tpa="tpaSelectedField"
              :data="dataPagamentoSelected" :trimestre="trimestreSelecionado" @pagamentoSucesso="pagamentoFeito"
              @fecharCard="fecharCardFinalizar" />
          </div>
        </div>
      </div>

      <div v-if="cardPagamentoFeito" class="cardComprovativo">
        <div class="pagamentosFeitosContainer">
          <pagmentosFeitos />
        </div>
        <v-btn @click="NovaVenda()" class="novo_paga_btn" color="blue">
          Novo Pagamento
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
const ls = require("local-storage");
import axios from "@/plugins/axios";
import funcaoPorROle from '@/utilitarios/funcao.untilitario'
import Swal from "sweetalert2";
import CardSuperior from "@/components/telaPagamentos/CardSuperior.vue";
import showNotifications from "@/components/notificacoes/ExibirAlertas.vue";
import NovoEstudante from "./componentes/novoPagamento/cadastrar.vue";
import informacoesPessoais from "@/components/estudantes/informacoesPessoais.vue";
import OptionSettingsPagamentos from "@/components/telaPagamentos/OptionSettingsPagamentos.vue";
import CardMaisEmolumentos from "@/components/telaPagamentos/CardMaisEmolumentos.vue";
import TabelaPagamento from "@/components/telaPagamentos/TabelaPagamento.vue";
import TelaFinalizarPagamento from "@/components/telaPagamentos/TelaFinalizarPagamento.vue";
import pagmentosFeitos from "./faturacao-vendas.vue";
import GerarSaldo from "@/components/pagamentos/GerarSaldo.vue";
import RegistroUnico from "@/components/pagamentos/RegistroUnico.vue";
import ConsultarPagamento from "@/components/pagamentos/ConsultarPagamento.vue";
import confirmarEstudante from "@/components/estudantes/confirmacao.vue";
import RegistrarBolseiro from "@/components/bolseiros/RegistrarBolseiro.vue";
import alertaEstudante from "@/components/estudantes/alertas.vue";
import editarEstudante from "@/components/estudantes/editar.vue";

export default {
  components: {
    CardSuperior,
    showNotifications,
    NovoEstudante,
    informacoesPessoais,
    OptionSettingsPagamentos,
    TabelaPagamento,
    CardMaisEmolumentos,
    TelaFinalizarPagamento,
    pagmentosFeitos,
    GerarSaldo,
    ConsultarPagamento,
    confirmarEstudante,
    RegistrarBolseiro,
    alertaEstudante,
    editarEstudante,
    RegistroUnico
  },
  data: () => ({
    infoPesoaisKey: 0,
    funcaoPorROle: funcaoPorROle,
    precosPropina: [],
    overlay: false,
    propinaExistente: [],
    menuSelected: undefined,
    estudanteResult: [],
    pesquisarAlertas: false,
    cardPagamentoFeito: false,
    saldoActual: 0,
    showFinalizar: false,
    dataPagamentoSelected: null,
    tpaSelectedField: [],
    popupExtraVisible: false,
    pagamentototais: null,
    pagamentoVenda: [],
    trimestreSelecionado: {
      id: 0,
      descricao: "Todos",
    },
    multiplasFormas: undefined,
    anolectivoSeleted: null,
  }),

  computed: {
    anoLectivoSistema() {
      return ls.get("anolectivo");
    }
  },

  async created() {
    await this.initializeAnosLectivo();
    await this.initializePrecoPropina();
  },

  methods: {
    async initializeAnosLectivo() {
      this.overlay = true;
      try {
        const response = await axios.get("/listarAnoLectivoAllFinancas");
        this.anolectivoSeleted = response.data.filter((a) => a.anolectivo == this.anoLectivoSistema)[0]
      } catch (error) {        
        Swal.fire(
          "Informação",
          "Erro ao carregar os anos lectivos!",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },
    async initializePrecoPropina() {
      try {
        this.overlay = true;
        this.precosPropina = await axios
          .get("/precoPropinaAll")
          .then((res) => res.data);
      } catch (error) {        
        Swal.fire(
          "Informação",
          "Erro ao carregar os preços da propina!",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    fecharTelaComponente() {
      this.PesquisaLocal(this.estudantePesquisa);
    },

    async PesquisaLocal(estudante) {
      this.NovaVenda();
      this.estudantePesquisa = estudante;

      // verifica se o preço de propina está definido
      this.propinaExistente = this.precosPropina.filter(
        (p) =>
          p.curso_id === estudante.curso_id &&
          p.classe_id === estudante.anoacademico
      );


      if (!this.propinaExistente.length) {
        Swal.fire(
          "Informação",
          "Definir o preço de propina para o curso deste estudante.",
          "warning"
        );
      } else {
        try {
          this.overlay = true;
          let result = await axios.post("/PesquisaEstudanteFin", estudante);
          if (result.status === 200) {
            if (result.data.length >= 1) {
              let dados = result.data[0];
              this.menuSelected = this.funcaoPorROle.opcaoCertaPagamento();
              this.estudanteResult = result.data;
              this.infoPesoaisKey += 1;
              this.pesquisarAlertas = true;
              this.aluno = dados;
            } else {
              Swal.fire("Informação", "Estudante não encontrado!", "info");
            }
          } else {
            Swal.fire("Informação", "Erro ao efectuar a operação!", "error");
          }
        } catch (error) {
          Swal.fire("Informação", "Erro ao efectuar a operação!", "error");
        } finally {
          this.overlay = false;
        }
      }
    },

    closeAlerta(bool) {
      this.pesquisarAlertas = bool;
    },

    SelectedMenuOption(option) {
      if (option == 9) {
        Swal.fire({
          title: "Atualizar Propinas",
          text: "Esta operação atualizará o preço das propinas ainda não pagas. Se o estudante estiver associado a propinas de uma classe ou curso incorreto, por favor, corrija a associação antes de prosseguir com esta operação.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Atualizar",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.atualizarPropinas();
          }
        });
      } else if (option == 11) {
        Swal.fire({
          title: "Remover Propinas de transporte",
          text: "Tem certeza que deseja remover as própinas de transporte?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.removerPropinasTransporte();
          }
        });
      } else if (option == 12) {
        Swal.fire({
          title: "Remover Propinas de cadeira",
          text: "Tem certeza que deseja remover as própinas de cadeira?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.removerPropinasCadeiras();
          }
        });
      } else {
        this.menuSelected = option;
      }
    },



    async atualizarPropinas() {
      try {
        let result = await axios.post(
          "/deletarPropinas",
          this.estudantePesquisa
        );
        if (result.status == 200) {
          this.$refs.tabelaComponent.$emit("carregarPagamentos");
          this.menuSelected = this.funcaoPorROle.opcaoCertaPagamento();
          Swal.fire(
            "Informação",
            "Própinas atualizadas com sucesso",
            "success"
          );
        } else {
          Swal.fire(
            "Erro",
            "Ocorreu um erro durante a atualização das própinas!",
            "error"
          );
        }
      } catch (error) {
        Swal.fire(
          "Erro",
          "Ocorreu um erro durante a atualização das própinas!",
          "error"
        );
      }
    },

    async removerPropinasTransporte() {
      try {
        let result = await axios.post(
          "/deletarPropinasTransporte",
          this.estudantePesquisa
        );
        if (result.status == 200) {
          this.$refs.tabelaComponent.$emit("carregarPagamentos");
          this.menuSelected = this.funcaoPorROle.opcaoCertaPagamento();
          Swal.fire(
            "Informação",
            "Propinas de transportes removidas com sucesso",
            "success"
          );
        } else {
          Swal.fire(
            "Erro",
            "Erro durante ao remover as própinas de transporte!",
            "error"
          );
        }
      } catch (error) {
        Swal.fire(
          "Erro",
          "Erro durante ao remover as própinas de transporte!",
          "error"
        );
      }
    },

    async removerPropinasCadeiras() {
      try {
        let result = await axios.post(
          "/deletarPropinasCadeiras",
          this.estudantePesquisa
        );
        if (result.status == 200) {
          this.$refs.tabelaComponent.$emit("carregarPagamentos");
          this.menuSelected = this.funcaoPorROle.opcaoCertaPagamento();
          Swal.fire(
            "Informação",
            "Propinas de cadeira removidas com sucesso",
            "success"
          );
        } else {
          Swal.fire(
            "Erro",
            "Erro durante a eliminação das própinas de cadeira!",
            "error"
          );
        }
      } catch (error) {
        Swal.fire(
          "Erro",
          "Erro durante a eliminação das própinas de cadeira!",
          "error"
        );
      }
    },

    pagamentoFeito(bool) {
      this.cardPagamentoFeito = bool;
    },

    NovaVenda() {
      this.overlay = false;
      this.propinaExistente = [];
      this.menuSelected = undefined;
      this.estudanteResult = [];
      this.pesquisarAlertas = false;
      this.cardPagamentoFeito = false;
      this.saldoActual = 0;
      this.showFinalizar = false;
      this.dataPagamentoSelected = null;
      this.tpaSelectedField = [];
      this.popupExtraVisible = false;
      this.pagamentototais = null;
      this.pagamentoVenda = [];
    },

    getSaldoestudante(saldo) {
      this.saldoActual = saldo;
    },

    settingSelected(tpas, bool) {
      this.multiplasFormas = bool;
      this.tpaSelectedField = tpas;
    },

    getData(data) {
      this.dataPagamentoSelected = data;
      this.$refs.tabelaComponent.$emit("carregarPagamentoData", data);
    },

    selectedTrimestre(trimestre) {
      this.trimestreSelecionado = trimestre;
      this.$refs.tabelaComponent.$emit("carregarPagamentoTrimestre", trimestre);
    },

    abrirCardMaisEMolumento(bool) {
      this.popupExtraVisible = bool;
      this.$refs.tabelaComponent.$emit("carregarPagamentos");
    },

    selecionarAnoLectivo(anoLectivo) {
      this.anolectivoSeleted = anoLectivo;
      this.$refs.tabelaComponent.$emit("carregarPagamentos");
    },

    PagamentoContinuar(dados) {

      try {
        if (
          (!this.multiplasFormas && this.tpaSelectedField.length != 1) ||
          (this.multiplasFormas && this.tpaSelectedField.length != 2)
        ) {
          Swal.fire(
            "Informação",
            "Por favor, selecione a data e forma(s) de pagamento!",
            "info"
          );
        } else {
          dados.totais.saldo = this.saldoActual;
          this.pagamentototais = dados.totais;
          this.pagamentoVenda = dados.venda;
          this.showFinalizar = true;
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Erro ao exibir a finalização de pagamento",
          "error"
        );
      }
    },

    fecharCardFinalizar(bool) {
      this.showFinalizar = bool;
    },
  },
};
</script>
<style>
.page-container {
  background-color: #f3f4f6;
  padding: 15px;
}


.top_image_container {
  background-color: #fff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding-bottom: 1rem;
}

.background_image_container {
  height: 150px;
}

.background_image_container .background_img {
  height: 100%;
}

.absolute {
  position: absolute;
  margin-top: 10px;
  border-radius: 0.25rem;
  width: 100%;
  text-align: right;
  padding: 0 5px 0 0;
}

.mt-negative20 {
  margin-top: -100px;
}

.one-third-width-2xl {
  font-size: 13px;
  background-color: #fff;
  padding: 2px 0 0 5px;
  margin: 0;
}

.card_titulos {
  font-size: 18px;
  padding: 10px;
  text-align: center;
}

ul.list_container_ul {
  text-align: left;
  padding: 0%;
}

.list_items_ul {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.list_items_ul .span_type {
  margin-right: 5px;
}

.shadow-xl {
  padding: 2px 0 0 5px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.top_option_pagamentos {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top_option_pagamentos .combox_containers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  margin-bottom: 5px;
}

.dialogoCardExtra {
  width: 80%;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);
  z-index: 100;
  padding: 3px;
  background-color: #9ff69f;
}

.totaisContainer {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 10px;
}

.bold_text_span_title {
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
}

.bold_text_span {
  font-weight: bold;
}

.botoesAccaoContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 5px 15px;
}

.text-bold {
  font-weight: bold;
}

.color-table-data {
  color: #141414;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.tabela-pagamento thead {
  background-color: #006699;
}

.tabela-pagamento th {
  color: #fff !important;
}

.align-totais {
  margin-left: 15px;
}

.totais-font-size {
  font-size: 17px;
}

.bg-white {
  background-color: #fff;
  color: #111827;
}

.w-full {
  width: 100%;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.font-bold {
  font-weight: 700;
}

.text-gray700 {
  color: #4b5563;
}

.items-center {
  align-items: center;
}

.w40 {
  width: 10rem;
}

.border4 {
  border-width: 0.25rem;
}

.border-white {
  border-color: #fff;
}

.rounded-full {
  border-radius: 50%;
}

.space-x2>*+* {
  margin-left: 0.5rem;
}

.mt2 {
  margin-top: 0.5rem;
}

.text-2xl {
  font-size: 1rem;
}

.bg-blue500 {
  background-color: #3b82f6;
}

.rounded-full {
  border-radius: 50%;
}

.p1 {
  padding: 0.25rem;
}

.text-gray100 {
  color: #f7fafc;
}

.h25 {
  height: 2.5rem;
}

.w25 {
  width: 2.5rem;
}

@media (min-width: 1536px) {
  .flex-row-2xl {
    flex-direction: row;
  }
}

.vertical-spacing {
  margin-top: 1rem;
}

@media (min-width: 1536px) {
  .no-vertical-spacing-2xl {
    margin-top: 0;
  }
}

@media (min-width: 1536px) {
  .horizontal-spacing-2xl {
    margin-left: 1rem;
  }
}

.flex-equal {
  flex: 1;
}

.background-white {
  background-color: #fff;
}

.rounded-border {
  border-radius: 1rem;
}

.elevated-shadow {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.padding-8 {
  padding: 2rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.w24 {
  width: 6rem;
}

.text-left {
  text-align: left;
}

.inline-block {
  display: inline-block;
}

@media (min-width: 1536px) {
  .w-23 {
    width: 66.6667%;
  }
}

.flex-1 {
  flex: 1;
}

.bg-white {
  background-color: #fff;
}

.rounded-lg {
  border-radius: 1rem;
}

.p8 {
  padding: 2rem;
}

.mt4 {
  margin-top: 1rem;
}

.w-30rem {
  width: 30rem;
}

.rounded {
  border-radius: 0.25rem;
}

.bg-white {
  background-color: #fff;
}

.border-none {
  border: none;
}

.bg-transparent {
  background-color: transparent;
}

.px4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.focus:focus {
  outline: none;
}

.mt-2 {
  margin-top: 0.5rem;
}

.block {
  display: block;
}

.w-40 {
  width: 10rem;
}

.h-10 {
  height: 2.5rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.border-gray-300 {
  border-color: #e5e7eb;
  border-width: 1px;
}

.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.focus2:focus {
  border-color: #3b82f6;
}

.focusring:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
  border-color: transparent;
}

.focusring-opacity-50:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.125);
  border-color: transparent;
}

.text-sm {
  font-size: 0.875rem;
}

.combo_container {
  padding: 10px;
  width: 25%;
  display: grid;
  grid-template-columns: 250px;
  justify-items: start;
}

.custom-tailwind-styles {
  width: 100%;
  border: none;
  background-color: transparent;
  padding: 1rem 4rem;
  color: #1a202c;
  outline: none;
}

.another-custom-class {
  display: flex;
  width: 30rem;
  border-radius: 0.375rem;
  background-color: #fff;
}

.botao_pesquisar {
  margin: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 600;
  color: #ffffff;
  background-color: #6b7280;
  cursor: pointer;
  border: none;
  outline: none;
}

.table-full {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  text-align: center;
}

.bg-gray100 {
  background-color: #f3f4f6;
}

.table_head {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem;
}

.table_data {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem;
}

.grid_container_cards {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 20px;
  width: 100%;
}

.content-display,
.details-container {
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tpaCombox {
  height: 55px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 5px;
}

.popup {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: top 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.popup-content {
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  width: 60%;
  margin-left: 200px;
}

.cardComprovativo {
  position: absolute;
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 600px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.pagamentosFeitosContainer {
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.cardComprovativo .novo_paga_btn {
  margin: 2px 0;
  font-weight: bold;
}

.operacoes_container {
  padding: 5px;
  margin: 0;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;
}

.operacoes_button {
  background-color: #efefef;
  border: 1px solid #8795a2;
  color: #656565;
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  margin-right: 10px;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  cursor: pointer;
  flex: 0 0 auto;
  margin-bottom: 10px;
  border-radius: 8px;
  flex-direction: row-reverse;
  height: auto;
}

.botao_selected {
  background-color: #c4d5e1;
}

.header {
  padding: 10px 20px;
  background-color: transparent;
  color: #fff;
  position: absolute;
  top: 5px;
}

.burger-button {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 20px;
}
</style>